
import { PropSync, Vue, Component, InjectReactive, Ref } from "vue-property-decorator";
import { DiagnosesType2Enum } from "@/enum/common.enum";
import { prescriptionCopy, getSourceMerchants } from "@/api/prescriptionDb";

import { ElForm } from "element-ui/types/form";

const keyNameMap = {
    pulse: "智能脉诊",
    tongue: "智能舌诊",
    physique: "体质辨识",
    lung: "肺功能",
    height: "智能体脂",
    four: "四诊合参",
    nurse: "调养方案",
    aiWeightTongue: "AI评估-体重管理（舌诊+体脂）",
    aiWeightPhy: "AI评估-体重管理（体质+体脂）",
}

const libNameMap = {
    pulse: "智能脉诊",
    tongue: "智能舌诊",
    physique: "体质辨识",
    lung: "肺功能",
    height: "智能体脂",
    four: "四诊合参",
    nurse: "调养方案",
    aiWeightTongue: "舌诊体脂",
    aiWeightPhy: "体质体脂",
}

@Component({})
export default class CopyPrescriptionDialog extends Vue {
    @PropSync("visible") dialogVisible !: boolean;
    @InjectReactive() merchantId!: string|number;
    @Ref("validateForm") validateFormRef: ElForm;

    keyNameMap = keyNameMap;

    formData = {
        pulse: [],
        tongue: [],
        physique: [],
        lung: [],
        height: [],
        four: [],
        nurse: [],
        aiWeightTongue: [],
        aiWeightPhy: [],
    }

    merchantData: Record<string, { merchantId: string | number | undefined; options: Array<any>; loading: boolean }> = {
        pulse: { merchantId: undefined, options: [], loading: false },
        tongue: { merchantId: undefined, options: [], loading: false },
        physique: { merchantId: undefined, options: [], loading: false },
        lung: { merchantId: undefined, options: [], loading: false },
        height: { merchantId: undefined, options: [], loading: false },
        four: { merchantId: undefined, options: [], loading: false },
        nurse: { merchantId: undefined, options: [], loading: false },
        aiWeightTongue: { merchantId: undefined, options: [], loading: false },
        aiWeightPhy: { merchantId: undefined, options: [], loading: false },
    }

    loading = false;

    get saveEnable() {
        return this.formKeys?.some((key: string) => {
            return this.formData[key]?.length;
        })
    }

    get formKeys() {
        return Object.keys(this.formData);
    }

    dialogClose() {
        this.validateFormRef?.resetFields();
        this.dialogVisible = false;
        this.resetMerchantData();
    }

    resetMerchantData() {
        this.formKeys?.forEach((key: string) => {
            this.merchantData[key].merchantId = undefined;
            this.merchantData[key].options = [];
            this.merchantData[key].loading = false;
        });
    }

    getSourceMerchantsList(key: string) {
        const item = this.merchantData[key];
        // 已加载过全量列表，后续由 el-select 的 filterable 在本地做模糊过滤
        if (item.options.length) return;
        item.loading = true;
        getSourceMerchants({
            currentMerchantId: this.merchantId,
            libCode: DiagnosesType2Enum[key],
            libName: libNameMap[key],
            name: "",
        }).then((res) => {
            item.loading = false;
            item.options = res.data || [];
        }).catch(() => {
            item.loading = false;
        });
    }

    handleMerchantChange(key: string) {
        this.formData[key] = [];
    }

    save() {
        const params = {
            targetMerchantId: this.merchantId,
            sourceCategories: this.formKeys?.map((key: string) => {
                return {
                    sourceMerchantId: this.merchantData[key].merchantId,
                    libCode: DiagnosesType2Enum[key],
                    libName: libNameMap[key],
                    preCategoryIds: this.formData[key],
                }
            })?.filter(el => el.preCategoryIds?.length)
        }
        this.loading = true;
        prescriptionCopy(params).then(() => {
            this.$message.success("操作成功");
            this.dialogClose();
        }).finally(() => {
            this.loading = false;
        })
    }

}
